import { useState, useEffect } from 'react';

const MusicPlayer = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [hasConsent, setHasConsent] = useState(false);

  useEffect(() => {
    // Check if user has accepted cookies (for GDPR compliance)
    const checkConsent = () => {
      const consent = localStorage.getItem('cookie-consent');
      if (consent === 'accepted') {
        setHasConsent(true);
      }
    };

    checkConsent();

    // Listen for consent changes
    const handleStorageChange = () => {
      checkConsent();
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Check periodically for same-tab updates
    const intervalId = setInterval(checkConsent, 1000);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(intervalId);
    };
  }, []);

  // Don't render if no consent
  if (!hasConsent) {
    return null;
  }

  return (
    <div 
      className="fixed bottom-20 right-4 z-40"
      data-testid="music-player"
    >
      {/* Collapsed state - just a button */}
      {!isExpanded && (
        <button
          onClick={() => setIsExpanded(true)}
          className="w-14 h-14 rounded-full bg-turquoise-400 text-white shadow-lg flex items-center justify-center hover:scale-110 transition-all hover:bg-turquoise-500"
          title="Unser Song: Herzen aus Licht"
          data-testid="music-toggle-btn"
        >
          <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"/>
          </svg>
        </button>
      )}

      {/* Expanded state - Mixcloud widget */}
      {isExpanded && (
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden" style={{ width: '300px' }}>
          {/* Header */}
          <div className="bg-turquoise-400 text-white px-4 py-3 flex items-center justify-between">
            <div>
              <p className="font-semibold text-sm">Unser Song</p>
              <p className="text-xs text-turquoise-100">Herzen aus Licht</p>
            </div>
            <button
              onClick={() => setIsExpanded(false)}
              className="w-8 h-8 rounded-full bg-white/20 hover:bg-white/30 flex items-center justify-center transition-colors"
              title="Minimieren"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
          </div>
          
          {/* Mixcloud Widget */}
          <div className="p-2">
            <iframe
              title="Großstadtherzen - Herzen aus Licht"
              width="100%"
              height="120"
              src="https://www.mixcloud.com/widget/iframe/?hide_cover=1&light=1&feed=%2FGro%C3%9Fstadtherzen%2Fherzen-aus-licht%2F"
              frameBorder="0"
              allow="autoplay"
              style={{ borderRadius: '8px' }}
            />
          </div>
          
          {/* Footer hint */}
          <div className="px-4 py-2 bg-gray-50 text-center">
            <p className="text-xs text-gray-500">Drücken Sie Play zum Abspielen</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default MusicPlayer;
